<template>
	<div class="content__column content__column--small" v-if="cupon">
		<h1 class="content__title">Editar / Crear Cupón</h1>
		<form class="form" @submit.prevent="saveCupon">
			<div class="form__fieldset">
				<div class="form__container">
					<label for="code" class="form__label form__label--required">Código del cupón</label>
					<input type="text" class="form__input" name="code" id="code" v-model="cupon.code" v-validate="validation.code" />
					<span v-show="errors.has('code')" class="form__alert" v-text="errors.first('code')"></span>
				</div>

				<div class="form__container">
					<label class="form__label form__label--required" for="type_id"> Tipo de cupón</label>
					<div class="form__select-container">
						<select name="type_id" id="type_id" class="form__select" v-validate="validation.type_id" v-model="cupon.type_id">
							<option hidden :value="null">Seleccione un tipo</option>
							<option v-for="(type, index) in cuponTypes" :key="index" :value="type.id" v-text="type.name"></option>
						</select>
					</div>
					<span v-show="errors.has('type_id')" class="form__alert" v-text="errors.first('type_id')"></span>
				</div>

				<div class="form__container">
					<label for="title_es" class="form__label">Titulo (Español)</label>
					<input type="text" class="form__input" name="title_es" id="title_es" v-model="cupon.title_es" v-validate="validation.title_es" />
					<span v-show="errors.has('title_es')" class="form__alert" v-text="errors.first('title_es')"></span>
				</div>

				<div class="form__container">
					<label for="title_en" class="form__label">Titulo (Inglés)</label>
					<input type="text" class="form__input" name="title_en" id="title_en" v-model="cupon.title_en" v-validate="validation.title_en" />
					<span v-show="errors.has('title_en')" class="form__alert" v-text="errors.first('title_en')"></span>
				</div>

				<div class="form__container">
					<label for="amount_mxn" class="form__label form__label--required">Monto en Pesos MXN</label>
					<input type="text" class="form__input" name="amount_mxn" id="amount_mxn" v-model="cupon.amount_mxn" v-validate="validation.amount_mxn" />
					<span v-show="errors.has('amount_mxn')" class="form__alert" v-text="errors.first('amount_mxn')"></span>
				</div>

				<div class="form__container">
					<label for="amount_usd" class="form__label form__label--required">Monto en Dólares USD</label>
					<input type="text" class="form__input" name="amount_usd" id="amount_usd" v-model="cupon.amount_usd" v-validate="validation.amount_usd" />
					<span v-show="errors.has('amount_usd')" class="form__alert" v-text="errors.first('amount_usd')"></span>
				</div>

				<div class="form__container">
					<label class="form__label form__label--required" for="usage_id"> Uso de cupón</label>
					<div class="form__select-container">
						<select name="usage_id" id="usage_id" class="form__select" v-validate="validation.usage_id" v-model="cupon.usage_id">
							<option hidden :value="null">Seleccione un uso</option>
							<option v-for="(usage, index) in cuponUsages" :key="index" :value="usage.id" v-text="usage.name"></option>
						</select>
					</div>
					<span v-show="errors.has('usage_id')" class="form__alert" v-text="errors.first('usage_id')"></span>
				</div>

				<div class="form__container">
					<label class="form__label form__label--required" for="status_id"> Estatus del cupón</label>
					<div class="form__select-container">
						<select name="status_id" id="status_id" class="form__select" v-validate="validation.status_id" v-model="cupon.status_id">
							<option hidden :value="null">Seleccione un estatus</option>
							<option v-for="(status, index) in cuponStatus" :key="index" :value="status.id" v-text="status.name"></option>
						</select>
					</div>
					<span v-show="errors.has('status_id')" class="form__alert" v-text="errors.first('status_id')"></span>
				</div>

				<div class="form__container">
					<label for="expiration_date" class="form__label">Fecha de Expiración</label>
					<input type="date" class="form__input" name="expiration_date" id="expiration_date" v-model="cupon.expiration_date" v-validate="validation.expiration_date" />
					<span v-show="errors.has('expiration_date')" class="form__alert" v-text="errors.first('expiration_date')"></span>
				</div>

				<div class="form__container">
					<label for="text1_es" class="form__label">Texto 1 (Español)</label>
					<input type="text" class="form__input" name="text1_es" id="text1_es" v-model="cupon.text1_es" v-validate="validation.text1_es" />
					<span v-show="errors.has('text1_es')" class="form__alert" v-text="errors.first('text1_es')"></span>
				</div>

				<div class="form__container">
					<label for="text2_es" class="form__label">Texto 2 (Español)</label>
					<input type="text" class="form__input" name="text2_es" id="text2_es" v-model="cupon.text2_es" v-validate="validation.text2_es" />
					<span v-show="errors.has('text2_es')" class="form__alert" v-text="errors.first('text2_es')"></span>
				</div>

				<div class="form__container">
					<label for="text1_en" class="form__label">Texto 1 (Inglés)</label>
					<input type="text" class="form__input" name="text1_en" id="text1_en" v-model="cupon.text1_en" v-validate="validation.text1_en" />
					<span v-show="errors.has('text1_en')" class="form__alert" v-text="errors.first('text1_en')"></span>
				</div>

				<div class="form__container">
					<label for="text2_en" class="form__label">Texto 2 (Inglés)</label>
					<input type="text" class="form__input" name="text2_en" id="text2_en" v-model="cupon.text2_en" v-validate="validation.text2_en" />
					<span v-show="errors.has('text2_en')" class="form__alert" v-text="errors.first('text2å_en')"></span>
				</div>

				<div class="form__container">
					<label for="popup" class="form__label">
						<input type="checkbox" class="form__checkbox" name="popup" id="popup" v-model="cupon.popup" v-validate="validation.popup" value="1" />
						Mostrar el producto en el popup de la página (Solo se mostrará uno en la página, debe desactivar esta opción en otros cupones para evitar que no se muestre)
					</label>
					<span v-show="errors.has('popup')" class="form__alert" v-text="errors.first('popup')"></span>
				</div>

				<div class="form__container">
					<label for="discount_on_discount" class="form__label">
						<input type="checkbox" class="form__checkbox" name="discount_on_discount" id="discount_on_discount" v-model="cupon.discount_on_discount" v-validate="validation.discount_on_discount" value="1" />
						Aplicar descuento sobre descuento  (*Por el momento no disponible en Knox)
					</label>
					<span v-show="errors.has('discount_on_discount')" class="form__alert" v-text="errors.first('discount_on_discount')"></span>
				</div>
			</div>
			<input type="submit" class="btn btn__action btn--regular" value="Guardar" />
			<button @click.prevent="$emit('new')" class="btn btn__transparent btn--regular">
				Agregar Nuevo Cupón
			</button>
		</form>
	</div>
</template>

<script>
	import httpService from '@/core/api/request'
	import Mixins from './mixins'
	import { defaultDateFormat } from '@/core/libs/functions'

	export default {
		props: {
			cupon: {
				type: Object,
				required: false,
				default: function() {
					return {
						id: null,
						code: null,
						type_id: null,
						usage_id: null,
						status_id: null,
						discount_on_discount: false,
						amount_mxn: null,
						amount_usd: null,
						expiration_date: null,
						text1_es: null,
						text1_en: null,
						text2_es: null,
						text2_en: null,
						popup: false,
						title_es: null,
						title_en: null
					}
				}
			}
		},
		mixins: [httpService, Mixins],
		data: function() {
			return {
				cuponStatus: null,
				validation: {
					cupon: 'required|max:20|min:5',
					status_id: 'required|min_value:1|max:1',
					date: 'date_format:yyyy-MM-dd',
					type_id: 'numeric|min_value:1|max:11|required',
					usage_id: 'numeric|min_value:1|max:11|required',
					amount_mxn: 'required|decimal|min_value:0.01',
					amount_usd: 'required|decimal|min_value:0.01',
					discount_on_discount: 'max:5',
					text1_es: 'max:150',
					text1_en: 'max:150',
					text2_es: 'max:150',
					text2_en: 'max:150',
					title_es: 'required|max:45',
					title_en: 'required|max:45'
				}
			}
		},
		created: function() {
			this.getCuponUsages()
			this.getCuponStatus()
			this.getCuponTypes()
		},
		methods: {
			saveCupon: function() {
				this.$validator.validateAll().then(result => {
					if (result) {
						let httpRequest = {
							params: '',
							module: 'discount_cupons',
							element: this.cupon
						}
						let action
						if (this.cupon.id) {
							action = this.put(this.cupon.id, httpRequest)
						} else {
							action = this.post(httpRequest)
						}
						action
							.then(response => {
								if (!this.cupon.id) {
									this.cupon.id = response.data.current_id
								}
								this.$store.commit('elementChanged', {
									module: 'cuponEdit',
									time: Math.round(new Date().getTime() / 1000)
								})
								this.$store.commit('notificate', {
									title: 'CUPÓN GUARDADO',
									text: 'El cupón ha sido guardado correctamente',
									type: 'success'
								})
							})
							.catch(() => {
								this.$store.commit('notificate', {
									title: 'CUPÓN NO GUARDADO',
									text: 'El cupón no pudo ser guardado por favor, intente más tarde',
									type: 'error'
								})
							})
					}
				})
			}
		}
	}
</script>

<style lang="sass">
	@import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/discount_cupons/edit.vue